module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "organizacion"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_c('div', {
    staticClass: "small-title"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-width": "938px",
      "margin": "auto"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.state.subTitle))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15pt"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.state.bannerTextBottom)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "3px solid red",
      "margin-top": "-80px",
      "margin-bottom": "80px"
    }
  }, [_c('div', {
    staticClass: "img-valores"
  }, [_c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_direccion.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt1))]), _vm._v(" "), _c('hr', {
    staticClass: "white-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_despacho.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt2))]), _vm._v(" "), _c('hr', {
    staticClass: "white-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_logistica.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.imgTxt3)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_contabilidad.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt4) + "\n                                    ")]), _c('div', {
    staticClass: "vertical-div",
    staticStyle: {
      "position": "absolute",
      "margin-left": "90px",
      "border-left": "2px solid #808080",
      "height": "30px"
    }
  }), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
    staticClass: "img-valores"
  }, [_c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_operador.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt5) + "\n                                    ")]), _c('div', {
    staticClass: "vertical-div",
    staticStyle: {
      "position": "absolute",
      "margin-left": "90px",
      "border-left": "2px solid #808080",
      "height": "30px"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr', {
    staticClass: "white-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_mecanica.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt6))]), _vm._v(" "), _c('hr', {
    staticClass: "white-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_ctpat.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt7))]), _vm._v(" "), _c('hr', {
    staticClass: "white-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_recursos.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt8))]), _vm._v(" "), _c('hr', {
    staticClass: "white-hr"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "img-valores left-align"
  }, [_c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_compras.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt9))]), _vm._v(" "), _c('hr', {
    staticClass: "white-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_administracion.png")
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt10))]), _vm._v(" "), _c('hr', {
    staticClass: "white-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/icon_almacen.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.state.imgTxt11))])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/icons/logo_santoyo_rojo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7917863e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nosotros/OrganizacionPage.vue
// module id = 148
// module chunks = 0